import axiosClient from 'api/axiosClient';
import API_MAP from 'constants/api';
import { CONTROL_PARTICIPANT_TYPE } from 'pages/mcu/components/constant';

export const mcuService = {
    getInfoRoom: async ({ roomId }) => {
        try {
            const res = await axiosClient.get(`${API_MAP.MCU.MONITOR_ROOM}/${roomId}/members/list`);

            return res;
        } catch (error) {
            return error?.response.data;
        }
    },
    getParticipantsInRoom: async () => {
        // Simulate fetching MCU data from an API
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve([
                    {
                        id: '1',
                        code: '1004',
                        type: 'sip',
                        address: '1004@10.61.11.42:3128',
                        status: 'connected',
                        micro: 0,
                        camera: 1,
                        sound: 1,
                        position: 0,
                        microVolume: 80,
                        soundVolume: 70,
                    },
                    {
                        id: '2',
                        code: '1005',
                        type: 'sip',
                        address: '1005@10.61.11.42:3128',
                        status: 'connected',
                        micro: 1,
                        camera: 1,
                        sound: 1,
                        position: 0,
                        microVolume: 22,
                        soundVolume: 55,
                    },
                    {
                        id: '3',
                        code: '1007',
                        type: 'sip',
                        address: '1007@10.61.11.42:3128',
                        status: 'connected',
                        micro: 1,
                        camera: 1,
                        sound: 1,
                        position: 0,
                        microVolume: 44,
                        soundVolume: 11,
                    },
                ]);
            }, 1000);
        });
    },
    controlParticipantRoom: async ({ roomId, type, participantId, value }) => {
        try {
            let _value = '';
            if (
                value !== undefined &&
                [CONTROL_PARTICIPANT_TYPE.VOLUME_IN, CONTROL_PARTICIPANT_TYPE.VOLUME_OUT].includes(type)
            ) {
                _value = `/${value}`;
            }
            await axiosClient.get(
                `${API_MAP.MCU.CONTROL_PARTICIPANT_ROOM}/${roomId}/${type}/${participantId}${_value}`,
            );
        } catch (error) {
            const message =
                error?.response?.data?.message || // message backend trả về
                error?.response?.data?.error || // nhiều API trả về { error: "..."}
                error?.message || // fallback message của Axios
                'Unknown error';

            console.log('Error message:', message);
        }
    },
    controlLockRoom: async ({ roomId, type }) => {
        try {
            await axiosClient.get(`${API_MAP.MCU.CONTROL_PARTICIPANT_ROOM}/${roomId}/${type}`);

        } catch (error) {
            const message =
                error?.response?.data?.message || // message backend trả về
                error?.response?.data?.error || // nhiều API trả về { error: "..."}
                error?.message || // fallback message của Axios
                'Unknown error';

            console.log('Error message:', message);
        }
    },
    controlKickMember: async ({ roomId, memberID }) => {
        try {
            const res = await axiosClient.get(`${API_MAP.MCU.CONTROL_PARTICIPANT_ROOM}/${roomId}/kick/${memberID}`);
            return res;
        } catch (error) {
            console.log(error);
        }
    },
    controlInviteMember: async ({ roomId, member }) => {
        try {
            const res = await axiosClient.get(`${API_MAP.MCU.CONTROL_PARTICIPANT_ROOM}/${roomId}/invite/${member}`);
            
            return res;
        } catch (error) {
            const message =
                error?.response?.data?.message || // message backend trả về
                error?.response?.data?.error || // nhiều API trả về { error: "..."}
                error?.message || // fallback message của Axios
                'Unknown error';

            console.log('Error message:', message);
        }
    },
    controlMuteOnEntry: async ({ roomId, isMute }) => {
        try {
            const type = isMute ? 'unmute-on-entry' : 'mute-on-entry'
            const res = await axiosClient.get(`${API_MAP.MCU.CONTROL_PARTICIPANT_ROOM}/${roomId}/${type}`);
            
            return res;
        } catch (error) {
            const message =
                error?.response?.data?.message || // message backend trả về
                error?.response?.data?.error || // nhiều API trả về { error: "..."}
                error?.message || // fallback message của Axios
                'Unknown error';

            console.log('Error message:', message);
        }
    }
};
